import { useCore } from "@spectral-finance/react-core";
import React, { createRef, useEffect } from "react";
import RetryLogo from "../../../../assets/retry.svg";
import SpectralLogo from "../../../../assets/spectral.svg";
import WalletLogo from "../../../../assets/wallet.svg";
import { useDialogStepsContext } from "../../../../contexts/DialogStepsContext";
import useMediaQuery from "../../../../hooks/useMediaQuery";
import { Box, BoxType } from "../../../Box";
import Flex from "../../../Flex";
import { OverlapLogos } from "../../../OverlapLogos";
import { VerifySignature } from "../VerifySignature";

import * as SC from "./WalletConnection.styles";

export const WalletConnection = () => {
  const { account } = useCore();
  const {
    connectWallet,
    forceingSwitchWallet,
    loadingSignature,
    onboardElement,
  } = useDialogStepsContext();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const walletListElement = createRef<HTMLDivElement>();

  // Add Onboard in the view and show list of providers
  useEffect(() => {
    if (onboardElement) {
      console.log({ onboardElement });
      walletListElement.current!?.appendChild(onboardElement);
    }
  }, [walletListElement.current, onboardElement]);

  useEffect(() => {
    connectWallet();
  }, []);

  if (loadingSignature) {
    return <VerifySignature />;
  }

  return (
    <SC.WalletConnectionContainer>
      <div>
        <OverlapLogos topImage={SpectralLogo} backImage={WalletLogo} />
        <h1>Available Wallets</h1>
        {!account.address && (
          <Box
            type={BoxType.FLAT}
            width="100%"
            height={isMobile ? "auto" : "94px"}
            margin="25px 0 0 0"
          >
            <Flex align="center" justify="between" width="100%">
              <img src={WalletLogo} alt="Spectral Wallet" />
              <SC.DisclaimerText>
                <b>Connect your wallet</b> and <b>sign a transaction</b> in
                order to verify ownership of the wallet.
              </SC.DisclaimerText>
            </Flex>
          </Box>
        )}
        {forceingSwitchWallet && account.isInBundleInProgress && (
          <Box type={BoxType.ERROR}>
            <Flex align="center" justify="between">
              <img src={RetryLogo} alt="Spectral Wallet" />
              <SC.DisclaimerText>
                You are still connected to your previous wallet, please switch
                to your new wallet in order to verify ownership.
              </SC.DisclaimerText>
            </Flex>
          </Box>
        )}
      </div>
      <SC.WalletList ref={walletListElement}></SC.WalletList>
    </SC.WalletConnectionContainer>
  );
};
